<template lang="pug">
  .component-action-bar
    .action-bar(:class="{inverted:inverted}")
        .title
          slot(name="title")
        .action
          slot(name="action")
</template>
<script type="text/babel">
    export default {
        name: 'ActionBar',
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {},
        props: {
            inverted: {
                type: Boolean,
                default: false
            },

        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-action-bar
    .action-bar
      display: flex
      //flex-direction: row
      justify-content: space-between
      .action
        display: flex
        flex-direction: row
        justify-content: flex-end
        align-items: center
        select
          padding: 0
          background-position: right 0 center
          height: auto
        *
          margin: 0 0.1em


</style>



// WEBPACK FOOTER //
// ActionBar.vue?46d93414